import axios from '../utils/axios';

export interface CreateStockAdjustmentDto {
  productId: string;
  type: 'increase' | 'decrease';
  qty: number;
  reason: string;
  notes?: string;
}

export class StockAdjustmentService {
  create(data: CreateStockAdjustmentDto) {
    const payload = {
      productId: data.productId,
      qtyAdjusted: data.type === 'increase' ? data.qty : -data.qty,
      reason: data.reason,
      notes: data.notes,
    };
    return axios.post('/stock/adjustments', payload);
  }

  createMany(data: CreateStockAdjustmentDto[]) {
    const payload = data.map((item) => ({
      productId: item.productId,
      qtyAdjusted: item.type === 'increase' ? item.qty : -item.qty,
      reason: item.reason,
      notes: item.notes,
    }));
    return axios.post('/stock/adjustments/batch', payload);
  }

  findAll(params?: { status?: string; page?: number; limit?: number; createdBy?: string }) {
    return axios.get('/stock/adjustments', { params });
  }

  updateStatus(id: string, status: 'Approved' | 'Rejected') {
    return axios.patch(`/stock/adjustments/${id}/status`, { status });
  }

  findOne(id: string) {
    return axios.get(`/stock/adjustments/${id}`);
  }
}
